<app-page [simpleTopBar]="globalVars.isMobile()" title="Reposts">
  <reposts-details></reposts-details>
</app-page>
